import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar/Sidebar';
import { ContentHeader } from './ContentHeader/ContentHeader';
import { BottomNav } from './BottomNav/BottomNav';
import styles from './AppLayout.module.scss';

interface AppLayoutProps {
    children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isDarkTheme, setIsDarkTheme] = useState(() => localStorage.getItem('expat_theme') === 'dark');
    const location = useLocation();

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const handleThemeToggle = useCallback(() => {
        const next = isDarkTheme ? 'light' : 'dark';
        setIsDarkTheme(!isDarkTheme);
        localStorage.setItem('expat_theme', next);
        document.documentElement.setAttribute('data-theme', next);
    }, [isDarkTheme]);

    const isAuthPage = location.pathname === '/' || location.pathname === '/auth/callback';

    if (isAuthPage) {
        return <div className={styles.authLayout}>{children}</div>;
    }

    return (
        <div className={styles.appLayout}>
            {isMobileMenuOpen && <div className={styles.mobileOverlay} onClick={() => setIsMobileMenuOpen(false)} />}

            <Sidebar
                isMobileOpen={isMobileMenuOpen}
                onMobileClose={() => setIsMobileMenuOpen(false)}
                onThemeToggle={handleThemeToggle}
                isDarkTheme={isDarkTheme}
            />

            <div className={styles.mainArea}>
                <ContentHeader
                    onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    onThemeToggle={handleThemeToggle}
                    isDarkTheme={isDarkTheme}
                />
                <main className={styles.mainContent}>{children}</main>
            </div>

            <BottomNav onThemeToggle={handleThemeToggle} isDarkTheme={isDarkTheme} />
        </div>
    );
}
